import { useEffect, useState } from "react";
import { getUser, isAuthenticated } from "../auth/auth";
import type { UserModel } from "../type/user";

export function useAuthUser(): UserModel | null {
  const [user, setUser] = useState<UserModel | null>(() =>
    isAuthenticated() ? getUser() : null
  );

  useEffect(() => {
    const syncUser = () => {
      setUser(isAuthenticated() ? getUser() : null);
    };

    syncUser();
    window.addEventListener("auth-change", syncUser);

    return () => window.removeEventListener("auth-change", syncUser);
  }, []);

  return user;
}
